import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  postFunGoalDependencies,
  postFunGoalKeyDecisions,
} from "../../store/actions";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import DeleteIcon from "../../assets/images/trash.svg";
import { AiOutlineCaretLeft, AiOutlineCaretRight } from "react-icons/ai";
import { resetExceptionError } from "../../store/actions/index.js";
import Alert from "../Alert.js";
import { motion } from "motion/react";
import { SlCalender } from "react-icons/sl";
import moment from "moment";
const ConstraintsPopUp = ({
  isEdit,
  isTaskSidebarOpen,
  setIsTaskSidebarOpen,
  setIsEdit,
  sidebarData,
  setConstraintsDisplay,
  setDependencyData,
  dependencyData,
}) => {
  const dispatch = useDispatch();
  const [fullScreenMode, setFullScreenMode] = useState(false);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(false);
  const ISError = useSelector((state) => state.ISError);
  const selectedSubMenuPermission = useSelector(
    (state) => state.selectedSubMenuPermission
  );
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    date: "",
    status: null,
  });
  useEffect(() => {
    if (sidebarData && isEdit) {
      console.log(sidebarData);
      setSelectedId(sidebarData.key);
      setFormData({
        title: sidebarData.title || "",
        description: sidebarData.value || "",
        date: sidebarData.date_time || "",
        status: sidebarData.status || "",
      });
    }
  }, [sidebarData]);

  const statusData = [
    {
      label: "Significant Risk/Late",
      value: "Significant Risk/Late",
    },
    {
      label: "At risk",
      value: "At risk",
    },
    {
      label: "On Track",
      value: "On Track",
    },
    {
      label: "Complete",
      value: "Complete",
    },
    {
      label: "On Hold",
      value: "On Hold",
    },
    {
      label: "Open",
      value: "Open",
    },
    {
      label: "In Progress",
      value: "In Progress",
    },
  ];
  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === "s") {
        event.preventDefault();
        handleSubmit();
      }
      if (event.key === "Escape") {
        event.preventDefault();
        closeTaskNav();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [formData]);
  const handleStatusSelect = (selectedOption) => {
    handleInputChange("status", selectedOption.value);
  };
  const handleInputChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };
  const handleFullScreen = () => {
    setFullScreenMode(true);
  };
  const handleMenuClick = () => {
    setMenuOpen(!isMenuOpen);
  };
  const closeTaskNav = () => {
    setIsTaskSidebarOpen(false);
    setIsEdit(false);
    setConstraintsDisplay(false);
  };
  const handleSideNav = () => {
    setFullScreenMode(false);
  };

  const handleSubmit = () => {
    if (formData.title !== "") {
      if (isEdit) {
        setIsTaskSidebarOpen(false);
        setIsEdit(false);
        setConstraintsDisplay(false);
        // If it's an edit, update the existing data
        dispatch(
          postFunGoalDependencies(
            false,
            false,
            formData.title,
            formData.description,
            formData.date,
            formData.status,
            "edit",
            selectedId
          )
        );
      } else {
        dispatch(
          postFunGoalDependencies(
            localStorage.getItem("functional_goal_id"),
            localStorage.getItem("goal_review_id"),
            formData.title,
            formData.description,
            formData.date,
            formData.status,
            "add"
          )
        );
        setIsTaskSidebarOpen(false);
        setConstraintsDisplay(false);
      }
    } else {
      Alert.warning({
        title: "Warning",
        text: "Title should not be empty",
        html: ISError,
        icon: "warning",
        preConfirm: (isConfirm) => {
          if (isConfirm) {
            dispatch(resetExceptionError());
          } else {
          }
        },
      });
    }
  };

  const handleDelete = () => {
    if (isEdit) {
      const updatedItems = dependencyData.filter(
        (item) => item.key !== selectedId
      );
      setDependencyData(updatedItems);
    }
    dispatch(
      postFunGoalDependencies(
        false,
        false,
        false,
        false,
        false,
        false,
        "delete",
        selectedId
      )
    );
    setIsTaskSidebarOpen(false);
  };

  return (
    <>
      <div>
        {isTaskSidebarOpen && (
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 1 }}
            exit={{ x: "100%" }}
            style={{
              width: fullScreenMode && "calc(100% - 50px)",
              height: "92vh",
              overflow: "hidden",
              zIndex: "100",
            }}
            className={"sidenav"}
          >
            <div
              style={{
                border: "1px solid lightgrey",
              }}
              className={"gtm-sidebar-header"}
            >
              <h5
                style={{
                  marginLeft: "20px",
                  fontSize: "var(--sub-heading-font-size)",
                  fontWeight: "var(--heading-font-weight)",
                }}
              >
                Constraints & Dependencies
              </h5>
              <>
                {(selectedSubMenuPermission === "write" ||
                  selectedSubMenuPermission === "admin") && (
                  <a href="#" className="sideMenu" onClick={handleMenuClick}>
                    <FontAwesomeIcon icon={faEllipsisH} />
                  </a>
                )}

                {isMenuOpen && (
                  <div className="menu">
                    <div className="Edit">
                      <div
                        className="DeleteOption"
                        onClick={(e) => handleDelete()}
                      >
                        <img
                          src={DeleteIcon}
                          width={"18px"}
                          style={{ marginRight: "10px" }}
                          alt="Edit Icon"
                        />
                        Delete
                      </div>
                    </div>
                  </div>
                )}

                {!fullScreenMode ? (
                  <a href="#" className="fullscreen" onClick={handleFullScreen}>
                    <AiOutlineCaretRight />
                  </a>
                ) : (
                  <a href="#" className="fullscreen" onClick={handleSideNav}>
                    <AiOutlineCaretLeft />
                  </a>
                )}
              </>

              <a href="#" className="closebtn" onClick={() => closeTaskNav()}>
                &times;
              </a>
            </div>
            <div className="gtm-sidebar-body">
              <input
                style={{
                  width: "98%",
                  margin: "auto",
                }}
                className="form-control"
                value={formData.title}
                placeholder="Add your title"
                onChange={(e) => handleInputChange("title", e.target.value)}
                disabled={
                  selectedSubMenuPermission === "write" ||
                  selectedSubMenuPermission === "admin"
                    ? false
                    : true
                }
              />
              <br />
              <div
                className="row"
                style={{
                  justifyContent: "space-between",
                }}
              >
                <div
                  className="col-6"
                  style={{
                    alignItems: "center",
                  }}
                >
                  <h6
                    style={{
                      margin: "0px 0px 0px 10px",
                      fontSize: "var(--sub-heading-font-size)",
                      fontWeight: "var(--heading-font-weight)",
                    }}
                  >
                    Date
                  </h6>
                   {/* Container for DatePicker with slight left margin and relative positioning(used to position calendar icon properly) */}
                  <div style={{ position: "relative", width: "100%", marginLeft: "10px" }}>
                    <DatePicker
                      selected={formData.date ? new Date(formData.date) : null} // Convert stored string (YYYY-MM-DD) → JS Date object for DatePicker
                      // When user selects/clears date:
                      // Convert Date → string (YYYY-MM-DD) and update state
                      onChange={(date) => handleInputChange("date", date ? new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split("T")[0] : "")}
                      dateFormat="yyyy-MM-dd" // Display format inside input
                      placeholderText="YYYY-MM-DD" // Placeholder when no date is selected
                      wrapperClassName="w-100"  // Makes DatePicker take full width
                      showMonthDropdown // Enable dropdowns for better UX (month & year selection)
                      showYearDropdown
                      dropdownMode="select"
                      customInput={  // Custom input field instead of default DatePicker input
                        <input className="form-control"
                          style={{
                            width: "100%",
                            fontSize: "var(--sub-heading-font-size)",
                          }}
                          readOnly
                        />
                      }
                      disabled={
                        selectedSubMenuPermission === "write" ||
                          selectedSubMenuPermission === "admin"
                          ? false
                          : true
                      }
                    />
                    <SlCalender
                      size={14}
                      color={formData.date ? "#28a745" : "gray"}
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "40%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                      }}
                    />
                  </div>
                </div>
                <div
                  className="col-6"
                  style={{
                    alignItems: "center",
                  }}
                >
                  <h6
                    style={{
                      margin: "0px",
                      fontSize: "var(--sub-heading-font-size)",
                      fontWeight: "var(--heading-font-weight)",
                    }}
                  >
                    Status
                  </h6>
                  <Select
                    required
                    className="status-select"
                    placeholder={
                      <span
                        style={{
                          fontSize: "var(--text-font-size)",
                          fontWeight: "400",
                        }}
                      >
                        Select Status
                      </span>
                    }
                    value={statusData.find(
                      (option) => option.value === formData.status
                    )}
                    options={statusData}
                    onChange={handleStatusSelect}
                    isSearchable={true}
                    getOptionLabel={(e) => (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <span
                          style={{
                            marginLeft: 5,
                            fontSize: "var(--text-font-size)",
                            fontWeight: "400",
                          }}
                        >
                          {e.label}
                        </span>
                      </div>
                    )}
                    isDisabled={
                      selectedSubMenuPermission === "write" ||
                      selectedSubMenuPermission === "admin"
                        ? false
                        : true
                    }
                  />
                </div>
              </div>
              <div
                style={{
                  margin: "0px 0px 0px 10px",
                  fontSize: "var(--sub-heading-font-size)",
                  fontWeight: "var(--heading-font-weight)",
                }}
              >
                Description
              </div>
              <textarea
                disabled={
                  selectedSubMenuPermission === "write" ||
                  selectedSubMenuPermission === "admin"
                    ? false
                    : true
                }
                style={{
                  width: "98%",
                  minHeight: "48vh",
                  margin: "auto",
                  fontSize: "var(--text-font-size)",
                }}
                className="form-control"
                value={formData.description}
                placeholder="Add your description"
                onChange={(e) =>
                  handleInputChange("description", e.target.value)
                }
              />
            </div>
            <br />
            <div
              className="strategy-sidebar-footer"
              style={{
                display: "flex",
                justifyContent: "right",
                width: "95%",
              }}
            >
              <div
                className="col-1"
                style={{
                  display: "flex",
                  marginTop: "2px",
                }}
              >
                <Button
                  type="button"
                  style={{
                    height: "35px",
                    position: "absolute",
                    top: "8px",
                    right: "150px",
                    padding: "4px 10px",
                    backgroundColor: "var(--button-primary-color)",
                    fontSize: "var(--sub-heading-font-size)",
                    border: "1px solid var(--button-primary-color)",
                  }}
                  onClick={() => handleSubmit()}
                  disabled={
                    selectedSubMenuPermission === "write" ||
                    selectedSubMenuPermission === "admin"
                      ? false
                      : true
                  }
                >
                  Save
                </Button>
              </div>
            </div>
          </motion.div>
        )}
      </div>
    </>
  );
};

export default ConstraintsPopUp;
